import * as React from "react";
import { UitkSpacing } from "./uitk-spacing.js";
export function UitkSpacingHr({
  blockMargin = "four"
}) {
  return /* @__PURE__ */ React.createElement(UitkSpacing, { border: ["blockstart"], margin: { block: blockMargin } }, /* @__PURE__ */ React.createElement("div", { className: "uitk-spacing-hr" }));
}
;
